import { FaTruck } from "react-icons/fa";

const PageLoader = () => {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-75 flex flex-col items-center justify-center z-50">
      <div className="relative">
        <FaTruck className="text-blue-600 text-6xl animate-bounce" />
      </div>
      <p className="mt-4 text-lg font-semibold text-gray-700">Loading...</p>
    </div>
  );
};

export default PageLoader;
